import { useCallback } from "react";

import { StackSuggestions } from "constants/stack";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from "ds/components/Table/Row/CellLabels";

import useLabelCellFilterAction from "../useLabelCellFilterAction";

const StacksTableLabelsCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const labelFilterAction = useLabelCellFilterAction({ labelCell: true });
  const folderFilterAction = useLabelCellFilterAction();

  const handleApplyLabelFilter = useCallback(
    (value: string) => {
      labelFilterAction({
        filterName: StackSuggestions.Label,
        filterValue: value,
      });
    },
    [labelFilterAction]
  );

  const handleApplyFolderFilter = useCallback(
    (value: string) => {
      folderFilterAction({
        filterName: StackSuggestions.Folder,
        filterValue: value,
      });
    },
    [folderFilterAction]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={stack.labels}
        applyLabelFilter={handleApplyLabelFilter}
        applyFolderFilter={handleApplyFolderFilter}
      />
    </TableSimpleCell>
  );
};

export default StacksTableLabelsCell;
